import { useEffect } from 'react';

const STRIPE_SCRIPT_ID = 'stripe-pricing-table-js';

type StripePricingTableProps = {
  pricingTableId: string;
  publishableKey: string;
  customerEmail: string;
  clientReferenceId: string;
};

const ensureStripePricingTableScript = () => {
  if (typeof document === 'undefined') {
    return;
  }
  if (document.getElementById(STRIPE_SCRIPT_ID)) {
    return;
  }
  const script = document.createElement('script');
  script.id = STRIPE_SCRIPT_ID;
  script.async = true;
  script.src = 'https://js.stripe.com/v3/pricing-table.js';
  document.body.appendChild(script);
};

const StripePricingTable = ({
  pricingTableId,
  publishableKey,
  customerEmail,
  clientReferenceId
}: StripePricingTableProps) => {
  useEffect(() => {
    ensureStripePricingTableScript();
  }, []);

  return (
    <stripe-pricing-table
      pricing-table-id={pricingTableId}
      publishable-key={publishableKey}
      customer-email={customerEmail}
      client-reference-id={clientReferenceId}
    />
  );
};

export default StripePricingTable;
export { ensureStripePricingTableScript };
